import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { SlideBarComponent } from './slide-bar.component';

@NgModule({
    imports: [TwcModule, CommonModule, FormsModule, TranslateModule],
    declarations: [SlideBarComponent],
    exports: [SlideBarComponent],
})
export class SlideBarModule {}
